import { InputLabel, styled } from "@mui/material";
import RadioButtonGroup from "../../../components/radio-button/radio-button-group";
import { useAppSelector } from "../../../redux/store";
import TooltipIcon from "../../../shared/component/tooltip-icon";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";
import { delimeterTypeOptions } from "../enums/file-delimeter";
import { terminatorTypeOptions } from "../enums/line-terminator";
import { UserPreferencesKeys } from "../interface/dto/user-preferences.dto";
import { tooltipsSelector } from "../redux/selectors/tooltips-selector";

interface IOwnProps {
    delimiterValue: string;
    terminatorValue: string;
    onOptionSelect: (
        value: string,
        fileFormatType: UserPreferencesKeys,
    ) => void;
    isLoading: boolean;
}

const FileFormat = ({
    className,
    delimiterValue,
    terminatorValue,
    onOptionSelect,
    isLoading,
}: IWithClassName & IOwnProps) => {
    const tooltips = useAppSelector(tooltipsSelector);

    const fileFormatTooltip = tooltips.fileFormat;

    return (
        <div className={className}>
            <div className="file-format">
                <div className="tooltip-container">
                    <InputLabel className="title">2. File Format</InputLabel>
                    <TooltipIcon content={fileFormatTooltip} />
                </div>
                <InputLabel className="file-label">File Delimiter</InputLabel>
                <RadioButtonGroup
                    onSelect={(value) =>
                        !isLoading &&
                        onOptionSelect(value, "fileFormatDelimiter")
                    }
                    options={delimeterTypeOptions}
                    value={delimiterValue}
                />
                <InputLabel className="line-label">Line Terminator</InputLabel>
                <RadioButtonGroup
                    onSelect={(value) =>
                        !isLoading &&
                        onOptionSelect(value, "fileFormatTerminator")
                    }
                    options={terminatorTypeOptions}
                    value={terminatorValue}
                />
            </div>
        </div>
    );
};

export default styled(FileFormat)(({ theme }: IWithThemeProps) => ({
    ".file-format": {
        width: 476,
        height: 266,
        borderRadius: 20,
        backgroundColor: theme?.palette.collapsibleFeatures.bgColor,
        boxSizing: "border-box",
        padding: theme?.spacing(2, 2, 4, 4),
    },
    ".tooltip-container": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    ".title": {
        fontWeight: "bold",
        color: theme?.palette.dropdown.listColor,
    },
    ".file-label, .line-label": {
        fontWeight: "bold",
        color: theme?.palette.dropdown.listColor,
        margin: theme?.spacing(1, 1, 0, 0),
    },
}));
